<template>
  <div class="success-page">
    <vs-row>
      <div class="vx-col w-full mb-base">
        <div class="success-message-parent bg-white">
          <div class="flex mb-0 success-message-flex-parent">
            <div class="mr-3 inline-block">
              <img class="align-middle" src="@/assets/images/campaigns/success-icon.svg"/>
            </div>
            <h5 class="inline-block font-bold success-message-header">
              {{ successMsg }}
                <span class="inline-block success-page-highlighted-text">
                  {{ $t('2 working days') }}
                </span>
            </h5>
          </div>
        </div>
        <tracking-sections></tracking-sections>
      </div>
    </vs-row>
  </div>
</template>
<script>
import TrackingSections from '@/views/campaigns/tracking/components/TrackingSections.vue'
export default {
  components: {
    TrackingSections
  },
  data () {
    return {
      pageCounts: {
        options: [10, 25, 50, 100]
      },
      itemsPerPage: 10,
      selectedPixelTrackingEvent: 'N/A',
      pixelTracking: {
        events: {},
        main_code: ''
      }
    }
  },
  async created () {
    await this.trackingDetails()
    this.selectedPixelTrackingEvent = this.pixelTracking.events.add_to_cart || 'N/A'
  },
  computed: {
    successMsg () {
      if (window.location.search.includes('edit=1')) {
        return this.$t('You have successfully updated your campaign. Our team will review the updated ads if any, and notify you within the next')
      }
      return this.$t('You have successfully created your campaign. Our team will review it, and notify you within the next')

    }
  },
  methods: {
    async getCampaign () {
      const response = await window.axios.get(`/campaigns/${this.$route.params.id}/insights`)
      this.campaign = response.data.payload
    },
    copyMainCode () {
      const copyText = document.getElementById('myInput')
      copyText.select()
      copyText.setSelectionRange(0, 99999)
      document.execCommand('copy')
    },
    copyEventsCode () {
      const copyText = document.getElementById('myInput2')
      copyText.select()
      copyText.setSelectionRange(0, 99999)
      document.execCommand('copy')
    },
    saveTextAsFile (textToWrite, fileNameToSaveAs) {
      const textFileAsBlob = new Blob([textToWrite], {type: 'text/plain'})
      const downloadLink = document.createElement('a')
      downloadLink.download = fileNameToSaveAs
      downloadLink.innerHTML = 'Download File'
      if (window.webkitURL !== null) {
        downloadLink.href = window.webkitURL.createObjectURL(textFileAsBlob)
      } else {
        downloadLink.href = window.URL.createObjectURL(textFileAsBlob)
        downloadLink.style.display = 'none'
        document.body.appendChild(downloadLink)
      }
      downloadLink.click()
    },
    saveMainCodeAsTxt () {
      this.saveTextAsFile(this.pixelTracking.main_code, 'installation_code.txt')
    },
    saveEventTriggerCodeAsTxt () {
      this.saveTextAsFile(`${this.selectedPixelTrackingEvent.event_trigger_code}, ${this.selectedPixelTrackingEvent.key} + _pixel__code.txt`)
    },
    async trackingDetails () {
      const response = await window.axios.get('/recommendations/get/pixel_tracking_details')
      if (!response.data.success) {
        return
      }
      this.pixelTracking.events = response.data.payload.events
      this.pixelTracking.main_code = response.data.payload.main_code
    }
  }
}
</script>

<style lang="scss">

$light-gray: #d8d8d8;
$speakol-color: #0092d7;

.success-page-highlighted-text {
  color: $speakol-color;
}

.success-message-header {
  font-size: 20px;
}

.success-message-flex-parent {
  align-items: center;
}

.vertical-divider {
  background-color: $light-gray;
  top: 10px;
}

.success-message-parent {
  border-radius: 15px;
  padding: 32px;
}

.edit-campagin-icon,
.show-all-campagin-icon {
  top: 3px;
  right: 5px;
}

.edit-campaigns-parent,
.show-all-campaigns-parent {
  border-bottom: 1px solid;
}

@media (max-width: 576px) {
  .success-card-parent {
    margin-top: 20px;
    display: grid;
  }

  .success-page {
    .vertical-divider {
      display: none !important;
    }
  }

  .show-all-campaigns-parent {
    margin-bottom: 20px;
  }
}

</style>
